var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKolonkaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DE1427;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.48,51.78h163.04v196.31H43.48V51.78z M70.36,242.92h109.27V54.21H70.36V242.92z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.11,35.21H55.89c-6.85,0-12.41,5.56-12.41,12.41v4.16h163.04v-4.16 C206.52,40.77,200.97,35.21,194.11,35.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "131,213.39 129.73,212.11 128.45,210.84 111.79,224.3 114.67,227.17 117.54,230.05  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.37,31.97H76.63c0-3.28,2.66-5.95,5.95-5.95h84.85C170.71,26.02,173.37,28.68,173.37,31.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.3,
    y: 2.82,
    className: "st0",
    width: 45.4,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92,149.2c0-3.28,2.66-5.95,5.95-5.95h54.11c3.28,0,5.95,2.66,5.95,5.95v82.64c0,3.28-2.66,5.95-5.95,5.95 H97.94c-3.28,0-5.95-2.66-5.95-5.95V149.2z M122.54,206.13c-7.75,0-14.03,6.28-14.03,14.03c0,7.75,6.28,14.03,14.03,14.03 c7.75,0,14.03-6.28,14.03-14.03C136.57,212.41,130.29,206.13,122.54,206.13z M104.11,215.97c1.21-4.44,3.65-7.81,6.71-10.12 c-0.27-0.36-0.54-0.71-0.81-1.07C106.99,207.61,104.89,211.41,104.11,215.97z M111.71,203.34c0.27,0.45,0.55,0.91,0.82,1.36 c2.82-1.66,6.02-2.53,9.25-2.62c-0.03-0.91-0.05-1.82-0.08-2.73C118.02,199.84,114.56,201.21,111.71,203.34z M124.04,199.17 c-0.08,0.99-0.16,1.97-0.24,2.96c3.22,0.24,6.38,1.27,9.12,3.09c0.77-1.14,1.55-2.29,2.32-3.43 C131.69,199.9,127.8,199.07,124.04,199.17z M145.89,214.5c-1.83-5.15-4.9-8.88-8.48-11.37c-0.95,1.12-1.89,2.23-2.84,3.35 c2.7,2.28,4.82,5.45,5.93,9.5C142.3,215.48,144.1,214.99,145.89,214.5z M106.82,173.36c0,10.04,8.14,18.18,18.18,18.18 c10.04,0,18.18-8.14,18.18-18.18c0-10.04-8.14-18.18-18.18-18.18C114.96,155.19,106.82,163.32,106.82,173.36z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.16,174.77c0.77,0.46,1.78,0.21,2.24-0.56c0.46-0.77,0.21-1.78-0.56-2.24 c-0.77-0.46-1.78-0.21-2.24,0.56C123.14,173.3,123.39,174.3,124.16,174.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 124.47,
    y: 154.93,
    className: "st0",
    width: 1.06,
    height: 4.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "132.55,156.53 131.57,156.13 129.98,159.97 130.96,160.37  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.49,
    y: 161.26,
    transform: "matrix(0.7069 -0.7073 0.7073 0.7069 -74.4099 144.0069)",
    className: "st0",
    width: 4.16,
    height: 1.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 138.04,
    y: 166.57,
    transform: "matrix(0.9237 -0.3831 0.3831 0.9237 -53.3294 66.4312)",
    className: "st0",
    width: 4.16,
    height: 1.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 139.28,
    y: 172.84,
    className: "st0",
    width: 4.16,
    height: 1.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 106.56,
    y: 172.84,
    className: "st0",
    width: 4.15,
    height: 1.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 109.35,
    y: 165.02,
    transform: "matrix(0.3833 -0.9236 0.9236 0.3833 -86.5747 204.5493)",
    className: "st0",
    width: 1.06,
    height: 4.16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 112.9,
    y: 159.72,
    transform: "matrix(0.7073 -0.7069 0.7069 0.7073 -81.173 127.5374)",
    className: "st0",
    width: 1.06,
    height: 4.16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "120.02,159.97 118.43,156.13 117.45,156.53 119.04,160.37  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "127.73,176 128.61,174.52 112.95,165.74 112.58,166.36  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKolonkaIcon);
export default __webpack_public_path__ + "static/media/kolonka_icon.691837c4b7d4c9ea560e224471e552b0.svg";
export { ForwardRef as ReactComponent };